import React from 'react';
import { Link } from 'react-router-dom'
import { Popover } from 'antd';

// styles
import './TranslationLabel.scss';

const TranslationLabel = ({
  label,
  tooltip,
  tooltipUrl,
  tooltipUrlTitle,
  selectedLanguage,
  ...moreProps
}) => {
  const tooltipContent = moreProps?.translations?.[selectedLanguage]?.tooltip
  const translationLabel = moreProps?.translations?.[selectedLanguage]?.title

  let content = (
    <div style={{ maxWidth: 300, wordBreak: "break-word" }}>
      {tooltipContent}
      <div className="tooltip__footer">
        <Link
          to={tooltipUrl}
          target="_blank"
          className="--link"
        >
          {tooltipUrlTitle}
        </Link>
      </div>
    </div>
  )

  const fieldLabel = translationLabel ? translationLabel : label

  return (
    <div
      className="rj-label-container"
      label={label}
      style={{
        paddingTop: 1.5,
        paddingBottom: label ? "auto" : ".5rem"
      }}>
      <p className="rj-label">
        {fieldLabel}
      </p>
      {tooltipContent && (
        <Popover
          content={content}
          title={null}>
          <i className="fal fa-info-circle" style={{ marginLeft: 8, marginBottom: 5, color: "#B9BCBF" }} />
        </Popover>
      )}
    </div>
  );
};

export default TranslationLabel;